import React from 'react';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './BenefitPlaceholder.scss';
const BenefitPlaceholder = ()=>/*#__PURE__*/ React.createElement(Flex, {
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement(CheckIcon, {
        className: s['icon'],
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['lines']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['line']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['line']
    })));
BenefitPlaceholder.displayName = 'BenefitPlaceholder';
export default BenefitPlaceholder;

//# sourceMappingURL=BenefitPlaceholder.js.map